import React from 'react'

export default function LoaderImage() {
    return (
        <div>
            <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
        </div>
    )
}
